import moment from "moment-timezone";

export const formatDateToPT = (date: Date | undefined | null) => {
  if (date !== undefined && date !== null) {
    return moment.utc(date).tz('Europe/Lisbon').format('YYYY-MM-DD');
  }
  return null;
};
